import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ChatStore from 'stores/ChatStore';
import CookieStorageService from 'services/CookieStorageService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import Button from 'components/Button/Button';
import BottomDrawer from 'components/BottomDrawer/BottomDrawer';
import SendQuickGift from 'components/SendQuickGiftModal/SendQuickGift';
import { YEAR_AS_SECONDS } from 'enum/timeFormat';
import allUserGroups from 'enum/userGroups';
import { generateID } from 'utils/helpers';

import giftIconUrl from '../../../images/performerVideo/icon-gift.png';

import styles from './MobilePlayerGiftButton.css';


const IDS = {
  prefix: 'HTTPyS10',
  element: 'MobilePlayerGiftButton',
  sendGift: 'sendGift',
};
const makeId = generateID(IDS.prefix, IDS.element);
const sendGiftId = makeId(IDS.sendGift);

const MobilePlayerGiftButton = (props) => {
  const { embedProfileV2, showBuyTokensModal } = props;
  const { toggleInteractionShown, isInteractionShown } = ChatStore;
  const { isPlayerBroadcastMode } = ProfileStore;
  const [quickGiftsOpened, setQuickGiftsOpened] = useState(false);
  const giftIcon = <img alt="" src={giftIconUrl} />;

  const handleGiftButton = useCallback(() => {
    setQuickGiftsOpened(true);
    CookieStorageService.set(
      'actionButtonId',
      IDS.sendGift,
      { maxAge: YEAR_AS_SECONDS });
  }, []);

  const closeQuickGifts = useCallback(() => {
    if (isInteractionShown) {
      toggleInteractionShown();
    }
    setQuickGiftsOpened(false);
  }, [isInteractionShown, toggleInteractionShown]);

  const classes = classnames(styles.buttonWrapper,
    { [styles.embedWrapper]: embedProfileV2 && UserStore.hasCF(allUserGroups.REALITY_SHOWS) }
  );

  return (
    <div className={classes}>
      <Button
        disabled={isPlayerBroadcastMode}
        icon={giftIcon}
        id={sendGiftId}
        onClick={handleGiftButton}
      />
      <BottomDrawer opened={quickGiftsOpened} onClose={closeQuickGifts}>
        <SendQuickGift close={closeQuickGifts} embedBuyTokens={showBuyTokensModal} embedProfileV2={embedProfileV2} />
      </BottomDrawer>
    </div>
  );
};

MobilePlayerGiftButton.propTypes = {
  embedProfileV2: PropTypes.bool,
  showBuyTokensModal: PropTypes.func,
};
MobilePlayerGiftButton.defaultProps = {
  embedProfileV2: false,
  showBuyTokensModal: () => undefined,
};

export default MobilePlayerGiftButton;
